import { render, staticRenderFns } from "./ProjectActivities.vue?vue&type=template&id=072e407c&"
import script from "./ProjectActivities.vue?vue&type=script&lang=js&"
export * from "./ProjectActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports